import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.connector.DOC}
  query IntegrationConnectors($tenantId: ID!, $zoneId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        intgConnectors {
          ...FragmentIntegrationConnector
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.IntegrationConnectorsQuery,
    readonly ents.core.integrations.Connector[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'intgConnectors',
        graphql.transformers.OUT.list(fragments.connector.TRANSFORMER, {
          onNullish: 'remove',
        }),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.IntegrationConnectorsQuery,
  readonly ents.core.integrations.Connector[],
  graphql.schema.IntegrationConnectorsQueryVariables
>({ query: DOC, transformer: TRANSFORMER })
